"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.R = void 0;
const Leaf = __importStar(require("leaf-ts"));
var R;
(function (R) {
    var _a;
    let WidgetCompileInfo;
    if (typeof NO_COMPILE_INFO === "undefined" || !NO_COMPILE_INFO) {
        WidgetCompileInfo = {
            "project": "/dev/shm/VersetProduction/verset-webapp.release/prod-497674fb-c4e34b12612d",
            "path": "src/script/probeHint/probeHint.html",
            "namespace": "R",
            "created": "2026-11-01 23:50:06"
        };
    }
    class ProbeHint extends Leaf.GeneratedWidget {
        static { _a = Leaf.CompileInfoSymbol; }
        constructor() {
            super(Leaf.WidgetThemeCenter.getThemeGenerator(ProbeHint), "ProbeHint", []);
            this.TestDatas = ProbeHint.TestDatas;
            this.BindedLists = ProbeHint.BindedLists;
            this.BindedWidgets = ProbeHint.BindedWidgets;
            this.InitialData = ProbeHint.InitialData;
            this.path = ProbeHint.path;
            this.GeneratedConstructor = ProbeHint;
            if (ProbeHint.InitialData) {
                this.renderRecursive(ProbeHint.InitialData);
            }
        }
        static { this[_a] = WidgetCompileInfo && {
            ...WidgetCompileInfo,
            namespace: "R.ProbeHint",
        }; }
        static { this.generator = function () {
            var _e = this._e.bind(this);
            var _t = this._t.bind(this);
            return _e("button", { "type": { "name": "type", "templates": [{ "type": "raw", "content": "button" }] }, "data-id": { "name": "data-id", "templates": [{ "type": "raw", "content": "openGuide" }] }, "aria-label": { "name": "aria-label", "templates": [{ "type": "raw", "content": "Connect a computer" }] }, "class": { "name": "class", "templates": [{ "type": "raw", "content": "probe-hint-7c0eef" }] } }, [_t({ "templates": [{ "type": "raw", "content": "\n    " }] }), _e("span", { "class": { "name": "class", "templates": [{ "type": "raw", "content": "eyebrow" }] } }, [_t({ "templates": [{ "type": "raw", "content": "Local access" }] })]), _t({ "templates": [{ "type": "raw", "content": "\n    " }] }), _e("span", { "class": { "name": "class", "templates": [{ "type": "raw", "content": "message" }] } }, [_t({ "templates": [{ "type": "raw", "content": "Connect a computer to use files and terminal tools from this workspace." }] })]), _t({ "templates": [{ "type": "raw", "content": "\n    " }] }), _e("span", { "class": { "name": "class", "templates": [{ "type": "raw", "content": "action" }] } }, [_t({ "templates": [{ "type": "raw", "content": "Connect computer" }] })]), _t({ "templates": [{ "type": "raw", "content": "\n" }] })]);
        }; }
        static { this.TestDatas = [{ "name": "default", "content": "", "json": {} }]; }
        static { this.BindedLists = []; }
        static { this.BindedWidgets = []; }
        static { this.path = "/script/probeHint/probeHint"; }
        static { this.widgetName = "ProbeHint"; }
        static { this.InitialData = null; }
    }
    R.ProbeHint = ProbeHint;
    ProbeHint["prototype"].widgetName = "ProbeHint";
})(R || (exports.R = R = {}));
if (typeof NO_LESS_IN_SOURCE === "undefined" || !NO_LESS_IN_SOURCE) {
    const lessContent = "\n.probe-hint-7c0eef {\n\n    & {\n        display: block;\n    }\n\n    button {\n        display: grid;\n        width: 100%;\n        box-sizing: border-box;\n        grid-template-columns: minmax(0, 1fr) auto;\n        gap: 6px 18px;\n        padding: 0;\n        border: 0;\n        background: transparent;\n        color: inherit;\n        text-align: left;\n        font: inherit;\n        cursor: pointer;\n    }\n\n    .eyebrow {\n        grid-column: 1 / -1;\n        color: #8a847c;\n        font-size: 10px;\n        font-weight: 700;\n        letter-spacing: .1em;\n        line-height: 1.3;\n        text-transform: uppercase;\n    }\n\n    .message {\n        color: #272522;\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 1.5;\n    }\n\n    .action {\n        align-self: end;\n        color: #111;\n        font-size: 12px;\n        font-weight: 650;\n        line-height: 1.5;\n        white-space: nowrap;\n    }\n\n    button:hover .action,\n    button:focus-visible .action {\n        text-decoration: underline;\n    }\n\n    button:focus-visible {\n        outline: 2px solid #8a847c;\n        outline-offset: 4px;\n    }\n\n\n}\n\n";
    const _global = globalThis;
    _global.lesses = _global.lesses || [];
    _global.lesses.push({ filename: __filename, less: lessContent });
}
